import { render } from "./product_in_warehouse.vue?vue&type=template&id=beed3aea&scoped=true"
import script from "./product_in_warehouse.vue?vue&type=script&lang=js"
export * from "./product_in_warehouse.vue?vue&type=script&lang=js"

import "./product_in_warehouse.vue?vue&type=style&index=0&id=beed3aea&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-beed3aea"]])

export default __exports__